import React from 'react'
import QrGeneralInfo from './QrGeneralInfo'
import { useNavigate } from 'react-router-dom'
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import QrCheckbox from './QrCheckbox';
import QrBulkQuantities from './QrBulkQuantities';

const QrDetails = (props) => {
    const { activeTab, detailInfo, setQRSetupModal, selectedInfo, setSelectedInfo } = props
    const navigate = useNavigate();

    const redirectBack = () => {
        setSelectedInfo(null)
        navigate('')
    }
    return (
        <div className={``}>
            <div className={`w-[100%] flex items-center justify-between`}>
                <div className={`layout-title flex items-center`}>
                    <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                        <ArrowBackIosOutlinedIcon />
                    </div>
                    <div>QR Details</div>
                </div>
            </div>
            <div className='my-8'>
                <QrGeneralInfo activeTab={activeTab} selectedInfo={selectedInfo} />               
                {activeTab === 'Bulk' ?
                    <QrBulkQuantities setQRSetupModal={setQRSetupModal} detailInfo={detailInfo} /> :
                    <QrCheckbox setQRSetupModal={setQRSetupModal} detailInfo={detailInfo} />}
            </div>
        </div>
    )
}

export default QrDetails